export default {
  // Molduras FIXAS do evento (personalizaTotem/{uid}.molduras). As molduras
  // globais continuam sendo lidas direto do Firestore pelo editor.
  molduras: [],
  carregado: false,
  // Totem a que a lista carregada pertence — troca de totem invalida o cache.
  totemId: null,
};
